import DashBoardSummaryCard from './DashBoardSummaryCard';

export default DashBoardSummaryCard;
